import PropTypes from 'prop-types';

// material-ui
import {  styled } from '@mui/material/styles';
import {  Box, Grid, Typography ,Button,Stack} from '@mui/material';

// third-party

// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonTotalOrderCard from 'ui-component/cards/Skeleton/EarningCard';



// assets

const CardWrapper = styled(MainCard)(({ theme }) => ({
  background: "linear-gradient(45deg, #6F9A15, #476605)", /* Example gradient from coral to peach */
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  '&>div': {
    position: 'relative',
    zIndex: 5
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: theme.palette.success[800],
    borderRadius: '50%',
    zIndex: 1,
    top: -85,
    right: -95,
    [theme.breakpoints.down('sm')]: {
      top: -105,
      right: -140
    }
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 210,
    height: 210,
    background: theme.palette.success[800],
    borderRadius: '50%',
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down('sm')]: {
      top: -155,
      right: -70
    }
  }
}));

// ==============================|| DASHBOARD - TOTAL ORDER LINE CHART CARD ||============================== //

const TotalOrderLineChartCardGreen = (props,{ isLoading }) => {

 
  return (
    <>
      {isLoading ? (
        <SkeletonTotalOrderCard />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2.25 }}>
            <Grid container direction="column">
              <Grid item>
                <Grid container justifyContent="space-between">
                  <Grid item xl={12}>
                    <Typography variant="h4" color="#E3F1C5">Hardware Wallet</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sx={{ mb: 0.75 }}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <Grid container alignItems="center">

                      <Grid item xl={6} textAlign='left'>
                        <Typography sx={{ fontSize: '2.125rem', fontWeight: 500, mt: 1.75, mb: 0.75 }} color="#CDF726">₹{props.summaryData?props.summaryData.wallet_balances.hardware_wallet_balance:"0"}</Typography>
                      </Grid>



                    </Grid>
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xl={12} justifyContent='flex-end' alignItems='flex-end'>
                
                <Stack direction='row' alignItems='center' justifyContent='space-between'>
                  <Typography variant='body1'>Compared to ₹ 0 Last Month</Typography>
                  <Button variant='outlined' size='small' sx={{
                    backgroundColor: '#fff', border: 'none', color: '#6A2F88', '&:hover': {
                      backgroundColor: '#f1f1f1',
                      color: '#6A2F88',
                      border: 'none',
                    },
                    
                  }}
                  onClick={()=>props.handleAddType("hardware")}
                  >Add Money</Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalOrderLineChartCardGreen.propTypes = {
  isLoading: PropTypes.bool
};

export default TotalOrderLineChartCardGreen;
